// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__16UCM","title":"AfterBackImages_title__3k5P8","images":"AfterBackImages_images__EAJ5a"};